import { TradeOrderStatusEnum } from '@sparling/financial-common'

const statuses = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in TradeOrderStatusEnum) {
  statuses.push({
    value: item,
    label: item,
  })
}

export const CRM_TRADING_STATUS = statuses
